import {
  Component,
  Input,
  ViewChild
} from '@angular/core';
import { BaseDropdownComponent } from '../_base-dropdown.component';
import { DropdownMenuComponent } from '../dropdown-menu/dropdown-menu.component';


@Component({
  moduleId: module.id,
  selector: 'square-arrow-dropdown',
  templateUrl: 'square-arrow-dropdown.component.html',
  styleUrls: ['square-arrow-dropdown.component.scss']
})
export class SquareArrowDropdownComponent extends BaseDropdownComponent {

  @Input() alignmentRight: boolean = false;

  @Input() arrowColor: string;

  @Input() borderHover: boolean = false;

  @ViewChild(DropdownMenuComponent, {static: false}) dropdownMenu: DropdownMenuComponent | void;

  onSelectedChange(selected: any) {
    this.selectedItem = selected;
    this.selectedChange.emit(selected);
  }

  public setActive(id: any, silent?: boolean) {
    if (this.dropdownMenu instanceof DropdownMenuComponent) {
      this.dropdownMenu.setActive(id, silent);
    }
  }
}
